import styled from 'styled-components';

const ContainerReviewHeaderScore = styled.div`
	display: flex;
	align-items: flex-end;
	margin: 0 0 16px 0;
`;

export default ContainerReviewHeaderScore;
